<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    
    <!-- Barre d'actions : Ajouter + Recherche -->
    <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <router-link
          v-if="checkPermission('AddComposition')"
          class="btn btn-primary"
          to="/ajouter-composition"
        >
          <i class="fa fa-plus-circle"></i>
          Ajouter une composition
        </router-link>
      </div>

      <div class="d-flex align-items-center">
        <form class="search-box position-relative" @submit.prevent="rechercher">
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher une composition"
          />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>

    <!-- Tableau -->
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Titre
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Date Composition
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Date Limite
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Professeur
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Filière
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Niveau
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Matière
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 pe-0">
                ACTIONS
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(composition, index) in compositions" :key="index">
               <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ composition.titre }}
                <!-- <span v-if="composition.hasDevoirs" class="badge-devoirs-soumis" title="Des devoirs ont été soumis">
                  <i class="fa fa-lock"></i> Bloqué
                </span> -->
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ formatDate(composition.dateComposition) }}
              </td>
              <td class="shadow-none lh-1 fw-medium">
                <span
                  v-if="composition.dateFinSoumission || composition.dateComposition"
                  :class="getDateStatusClass(composition.dateFinSoumission || composition.dateComposition)"
                >
                  {{ formatDate(composition.dateFinSoumission || composition.dateComposition) }}
                  <small
                    v-if="joursRestants(composition) > 0 && joursRestants(composition) <= 3"
                    class="d-block text-warning"
                  >
                    J-{{ joursRestants(composition) }}
                  </small>
                  <small v-if="joursRestants(composition) <= 0" class="d-block text-danger">
                    Expirée
                  </small>
                </span>
                <span v-else class="text-muted">Non définie</span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ fullName(composition.professeur) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ composition.filiereNiveauMatiere?.filiere?.libelle || '-' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ composition.filiereNiveauMatiere?.niveau?.libelle || '-' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ composition.filiereNiveauMatiere?.matiere?.libelle || '-' }}
              </td>

              <!-- ACTIONS -->
              <td class="shadow-none lh-1 fw-medium text-body-tertiary pe-0">
                <div class="dropdown">
                  <span
                    class="badge text-white bg-primary fs-15 dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Actions
                    <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu dropdown-block">
                    <!-- Détails -->
                    <li>
                      <router-link
                        :to="{ name: 'ViewCompositionPage', params: { id: composition.id } }"
                        class="dropdown-item d-flex align-items-center"
                      >
                        <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>
                        Détails
                      </router-link>
                    </li>

                    <!-- Télécharger PDF -->
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click="downloadPdf(composition.id, composition.titre)"
                        class="dropdown-item d-flex align-items-center"
                        :class="{ 'text-muted': !composition.pdfUrl }"
                        :title="!composition.pdfUrl ? 'PDF non disponible' : ''"
                      >
                        <i class="flaticon-download lh-1 me-8 position-relative top-1"></i>
                        Télécharger PDF
                        <!-- <small v-if="!composition.pdfUrl" class="ms-2">(en cours...)</small> -->
                      </a>
                    </li> 

                    <!-- SÉPARATEUR UNIQUEMENT SI ACTIONS DISPONIBLES -->
                    <hr v-if="canShowEditOrDelete(composition)" class="dropdown-divider">

                    <!-- MODIFIER - N'AFFICHE QUE SI PAS DE DEVOIRS -->
                    <li v-if="canEdit(composition) && !composition.hasDevoirs">
                      <router-link
                        :to="{ name: 'EditCompositionPage', params: { id: composition.id } }"
                        class="dropdown-item d-flex align-items-center"
                      >
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        Modifier
                      </router-link>
                    </li>

                    <!-- SUPPRIMER - N'AFFICHE QUE SI PAS DE DEVOIRS -->
                    <li v-if="canDelete(composition) && !composition.hasDevoirs">
                      <a
                        href="javascript:void(0);"
                        @click="suppression(composition.id, compositions, 'compositions', `la composition ${composition.titre}`)"
                        class="dropdown-item d-flex align-items-center text-danger"
                      >
                        <i class="fa fa-trash-o lh-1 me-8 position-relative top-1"></i>
                        Supprimer
                      </a>
                    </li>

                    <!-- MESSAGE INFORMATIF SI BLOQUÉ -->
                    <li v-if="composition.hasDevoirs && canEditOrDelete(composition)">
                      <span class="dropdown-item d-flex align-items-center text-muted disabled-info">
                        <i class="fa fa-info-circle lh-1 me-8 position-relative top-1"></i>
                      (Devoirs soumis pour cette composition déjà)
                      </span>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent
          :page="page"
          :totalPages="totalPages"
          :totalElements="totalElements"
          :limit="limit"
          @paginate="handlePaginate"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import Swal from "sweetalert2";
import { Composition } from "@/models/Composition";
import ApiService from "@/services/ApiService";
import { suppression, error } from "@/utils/utils";
import PaginationComponent from "@/components/Utilities/Pagination.vue";
import JwtService from "@/services/JwtService";
import { useAuthStore } from "@/services/auth";

export default defineComponent({
  name: "ListeComposition",
  components: {
    PaginationComponent,
  },
  setup() {
    const authStore = useAuthStore();
    const compositions = ref<Composition[]>([]);

    interface CompositionWithStatus extends Composition {
      estExpire: boolean;
      joursRestants: number;
      hasDevoirs: boolean;
    }

    // Pagination & Recherche
    const searchTerm = ref("");
    const page = ref(1);
    const limit = ref(10);
    const totalPages = ref(0);
    const totalElements = ref(0);

    onMounted(() => {
      getAllComposition();
    });

    function rechercher(){
      getAllComposition(page.value, limit.value, searchTerm.value );
    }

    // END PAGINATE

    function getAllComposition(page = 1, limi = 10, searchTerm = '') {
      return ApiService.get(`/all/compositions?page=${page}&limit=${limi}&mot=${searchTerm}&`)
        .then(({ data }) => {
          compositions.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => {
          error(response.data.message)
      });
    }

    const handlePaginate = ({ page_, limit_ }: { page_: number; limit_: number }) => {
      page.value = page_;
      limit.value = limit_;
      getAllComposition(page_, limit_, searchTerm.value);
    };

    // Helpers d'affichage
    const formatDate = (date: string | null): string => {
      return date ? new Date(date).toLocaleDateString("fr-FR") : "-";
    };

    const fullName = (prof: any): string => {
      if (!prof) return "-";
      return `${prof.nom || ""} ${prof.prenom || ""}`.trim() || "Inconnu";
    };

    const joursRestants = (comp: Composition): number => {
  const date = comp.dateFinSoumission || comp.dateComposition;
  if (!date) return Infinity;

  const fin = new Date(date);

  //  IMPORTANT : on ajoute 1 jour complet
  const finIncluse = new Date(fin);
  finIncluse.setDate(finIncluse.getDate() + 1);

  const today = new Date();

  // Normaliser les heures pour éviter les erreurs
  today.setHours(0, 0, 0, 0);
  finIncluse.setHours(0, 0, 0, 0);

  const diff = finIncluse.getTime() - today.getTime();

  return Math.ceil(diff / (1000 * 60 * 60 * 24));
};


    const getDateStatusClass = (dateStr: string | null): string => {
      if (!dateStr) return "text-muted";
      const jours = joursRestants({ dateFinSoumission: dateStr } as any);
      if (jours < 0) return "text-danger fw-bold";
      if (jours <= 3) return "text-warning fw-bold";
      return "text-success";
    };

    const downloadPdf = (id: number, titre: string) => {
      ApiService.get(`/compositions/${id}/download-pdf`, { responseType: "blob" })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${titre.replace(/[^a-z0-9]/gi, "_")}.pdf`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(() => {
          error("PDF non disponible ou erreur de téléchargement");
        });
    };

    // Permissions
    const privileges = ref<string[]>(JwtService.getPrivilege());
    const isProfesseur = !!authStore.user?.professeur?.id;

    const checkPermission = (perm: string) => privileges.value.includes(perm);

    const canEdit = (c: Composition) =>
      checkPermission("EditComposition") ||
      (isProfesseur && c.professeur?.id === authStore.user?.professeur?.id);

    const canDelete = (c: Composition) =>
      checkPermission("DeleteComposition") ||
      (isProfesseur && c.professeur?.id === authStore.user?.professeur?.id);

    const canEditOrDelete = (c: Composition) => canEdit(c) || canDelete(c);

    //  NOUVELLE FONCTION : Afficher le séparateur/actions uniquement si nécessaire
    const canShowEditOrDelete = (c: Composition) => {
      return canEditOrDelete(c) && !c.hasDevoirs;
    };

    return {
      compositions,
      searchTerm,
      page,
      totalPages,
      totalElements,
      limit,
      rechercher,
      handlePaginate,
      formatDate,
      fullName,
      joursRestants,
      getDateStatusClass,
      downloadPdf,
      suppression,
      checkPermission,
      canEdit,
      canDelete,
      canEditOrDelete,
      canShowEditOrDelete,
    };
  },
});
</script>

<style scoped>
.search-bg.svg-color {
  min-width: 280px;
}

/*  Style pour le message informatif */
.disabled-info {
  cursor: default;
  font-size: 0.85rem;
  font-style: italic;
  background-color: #f8f9fa;
}

.disabled-info:hover {
  background-color: #f8f9fa;
}

/* Badge de warning pour compositions avec devoirs */
.badge-devoirs-soumis {
  display: inline-block;
  padding: 2px 8px;
  font-size: 10px;
  background-color: #ffc107;
  color: #000;
  border-radius: 12px;
  margin-left: 8px;
  font-weight: 600;
}
</style>